import React from 'react';

interface DillCardProps {
  children: React.ReactNode;
  title?: string;
  className?: string;
}

export const DillCard = ({ children, title, className }: DillCardProps) => (
  <div
    className={`rounded-xl border border-gray-100 bg-gray-50 p-5${
      className ? ` ${className}` : ''
    }`}>
    {title && (
      <span className="mb-4 block text-[10px] uppercase tracking-[0.15em] text-blue-600">
        {title}
      </span>
    )}
    {children}
  </div>
);
